export const environment = {
    siteId: 1,
    name: 'theseaclub',
    apiBaseUrl: 'https://theseaclub-api-dev.clicktotravel.es/api',
    baseUrl: 'https://theseaclub-api-dev.clicktotravel.es/',
    token: '',
    email: 'front@clicktotravel.es',
    password: 'TZht@ou.eA2vz4qrQ@7B',
    userPanel: 'admin',
    passPanel: '1234',
    booking_engine_enabled: true, // General switch for booking engine
    booking_engine_top_enabled: true, // Switch for booking engine button in top sliders
    booking_engine_extern: false,
    booking_button_engine_enabled: false, // Button booking engine
    openInNewWindow: false,
    trailingSlash: false,
    multipleMotorsModal: false,
    hotelRequestMotor: false, // Add request hotel motor
    normalizeUrlsToLowercase: true,
    minSizeMobileHeader: 768,
    menuComplexLinks: false,
    booking_engine_widget: false, // Use widget booking engine
    booking_engine_widget_dynamic: false, // widget static down
    dataBase: '../data/',
    sitesIndexFile: 'sites.json',
    organizationName: 'babylon',
    hideUserCentrics: true, //Only for dev on true
    fallbackUrl: 'https://dev-theseaclub.clicktotravel.es/',
};
